<template>
    <div :class="formClass">
        <!-- fb按鈕 -->
        <div id="fb-root"></div>
        <template v-if="pageType == 'product' ">
            <template v-if="productType == 'tightBundle'">
                <div class="purchase-info">
                    <h1 class="title">
                        {{ product.name }}
                    </h1>
                    <div class="priceBox">
                        <div class="priceBoxLeft">
                            <span class="originalPrice" v-if="originalPrice">{{ originalPrice }}</span>
                            <div class="price" v-if="salePrice">{{ salePrice }}</div>
                        </div>
                        <div class="priceBoxRight">
                            <div class="ratingNumber">
                                <img :src="starIcon" alt="icon">{{ ratingScore }}
                                <span v-if="ratingCount != 0">({{ ratingCount }})</span>
                            </div>
                            <div class="soldCount">已賣出：{{ allSalesTimes }} 件</div>
                        </div>
                    </div>
                    <div class="synopsis" v-if="product.synopsis" v-html="product.synopsis"/>
                    <div class="specTitle">包含以下產品</div>
                    <template v-if="productCombination">
                        <template v-for="(items, id) in productCombination">
                            <div class="bundle-item">
                                <div class="bundle-head flex">
                                    <img class="class-pic" :src="getCombinationCoursePic(items)"
                                         @error="handleImageError" alt="">
                                    <div class="info flex">
                    <span class="class-name">
                      <a
                          v-bind:href="'product/' + getCombinationParentSlug(items)"
                          v-text="getCombinationParentName(items)">
										        </a>
                      <input type="hidden" class="type_id_specId_key"
                             :data-type_id_specId_key="(id, selectedProductCombinationIds[id])"
                             name="type_id_specId_key[]"
                             :value="typeIdSpecIdKey(id, selectedProductCombinationIds[id])">
                    </span>
                                        <!-- 數量 -->
                                        <span class="class-amount">數量：{{ getProductCombinationAmount(id) }}</span>
                                        <div class="stock-less" v-if="specification">剩餘數量：{{
                                                getStockNum(id)
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="item-option">
                                    <div class="class-icon">
                                        <div class="class-icon-pic">
                                            <font-awesome-icon :icon="['fas', 'swatchbook']"/>
                                        </div>
                                        款式
                                    </div>
                                    <select class="drop-down-triangle"
                                            @change="updateSelectedProductCombinationId(id, $event.target.value)">
                                        <option v-for="item in items" :value="item.id">{{ item.name }}
                                        </option>
                                    </select>
                                    <div class="custom-arrow"></div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <div class="stock">
                        <div class="specTitle">數量</div>
                        <div class="stockInputBox">
                            <button class="qty minus" @click="decrement">-</button>
                            <input
                                type="number"
                                name="amount"
                                :value="inputAmount"
                                :min="1"
                                :max="10000"
                            >
                            <button class="qty plus" @click="increment">+</button>
                        </div>
                    </div>
                </div>
                <div class="cart-item">
                    <div class="cart-form">
                        <button
                            type="button"
                            class="btn cart-button"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="馬上購買"
                            @click="handleSubmit(cartAction)"
                            :disabled="lockBtn"
                        >馬上購買
                        </button>
                    </div>
                    <div class="addcart-form">
                        <button
                            type="button"
                            class="btn addcart-btn"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="加入購物車"
                            @click="handleSubmit(cartNoJumpAction)"
                            :disabled="lockBtn"
                        />
                    </div>
                </div>
                <div class="cart-bottom">
                    <div class="fb-like" :data-href="fbLikeUrl" data-width=""
                         data-layout="button" data-action="like" data-size="small"
                         data-share="true"></div>
                    <ProductFavoriteComponent
                        :id="product.id"
                        :favorite-added="favoriteAdded"
                        :favorite-added-data="favoriteAddedData"
                        @change-favorite-added-data="handledChangeFavorite"
                        :page-type="'product'"
                    ></ProductFavoriteComponent>
                </div>
            </template>
            <template v-else>
                <h1 class="title">{{ product.name }}</h1>
                <input type="hidden" class="type_id_specId_key" :data-type_id_specId_key="typeIdSpecIdKey()"
                       name="type_id_specId_key[]" :value="typeIdSpecIdKey()">
                <!--     預購    -->
                <div class="fundraising-item" v-if="product.ProductField?.preorderActive">
                    <div class="reciprocal-item">
                        <span class="reciprocal-title" v-html="preOrderTitle"></span>
                        <p v-if="remainingTime.distance > 0">
                            <span id="day">{{ remainingTime.days }}</span> 天
                            <span id="hour">{{ remainingTime.hours }}</span> 時
                            <span id="minute">{{ remainingTime.minutes }}</span> 分
                            <span id="seconds">{{ remainingTime.seconds }}</span> 秒
                        </p>
                        <p v-else>
                            活動已結束
                        </p>
                    </div>
                    <div class="aims-item">
                        <div class="aims-line">
                            <div class="aims-number">
                                <div class="aims-icon"><img src="img/pic/purchase.png" alt=""></div>
                                目標 {{ product.ProductField.preorderReachSales }} 人
                            </div>
                            <div class="buy-number">{{ product.baseSalesTime + product.salesTime }} 人 已購買</div>
                        </div>
                        <div class="progress" style="height: 6px;">
                            <div class="progress-bar" id="progress-bar" role="progressbar"
                                 :style="'width:' +product.salesTimePercent+'%;'"
                                 aria-valuenow="25"
                                 aria-valuemin="0" aria-valuemax="100" tabindex="0"
                                 data-toggle="tooltip" title="0%"></div>
                            <b-tooltip target="progress-bar"
                                       placement="right">{{ product.salesTimePercent }}%
                            </b-tooltip>
                        </div>
                        <small>在 {{ formatDate(product.ProductField.preorderToDate) }}
                            預購結束前，達到 {{ product.ProductField.preorderReachSales }} 人便預購成功</small>
                    </div>
                </div>
                <div class="priceBox">
                    <div class="priceBoxLeft">
                        <div class="originalPrice" v-if="product.priceOriginal > 0">NT$ {{
                                product.priceOriginal
                            }}元
                        </div>
                        <div class="price" v-if="specification.price > 0" v-cloak>NT$ {{ specification.price }}
                            元
                        </div>
                        <div class="price" v-else-if="specification.price == 0" v-cloak>免費</div>
                    </div>
                    <div class="priceBoxRight">
                        <div class="ratingNumber"><img src="img/pic/star.png" alt="">{{
                                ratingScore
                            }}<span>({{ ratingCount }})</span></div>
                        <div class="soldCount">已賣出：{{ (product.baseSalesTime + product.salesTime) ?? 0 }} 件
                        </div>
                    </div>
                </div>
                <div class="specTitle" v-show="specifications.length > 0">款式</div>
                <div
                    class="SpecificationPicker"
                    v-if="specifications.length > 0"
                    v-cloak
                >
                    <template v-for="(specification, key) in specifications">
                        <span
                            :key="key"
                            :class="{
                                specificationBtn: specification[0].newStocknum > 0,
                                invalidSpecificationBtn: specification[0].newStocknum <= 0,
                                active: specification[0].id === selectedProgramId
                            }"
                            v-text="specification[0].name"
                            @click="selectSpec(specification[0])"
                        >
                        </span>
                    </template>
                </div>
                <div class="stock" v-show="specifications.length > 0">
                    <div class="specTitle">數量</div>
                    <div class="stockInputBox">
                        <button class="qty minus" v-on:click="decrement">-</button>
                        <input
                            id="stockInput"
                            type="number"
                            name="amount"
                            v-model="inputAmount"
                            :min="1"
                            :max="10000"
                        >
                        <button class="qty plus" v-on:click="increment">+</button>
                    </div>
                    <div class="stockText">剩餘數量：{{
                            specification.activeNewStockRule ?
                                specification.newStocknum :
                                specification.stocknum
                        }}
                    </div>
                </div>
                <div class="synopsis" v-if="product.synopsis" v-html="product.synopsis">
                </div>
                <div class="cart-item" v-show="specifications.length > 0">
                    <div class="cart-form">
                        <button
                            type="button"
                            class="btn cart-button"
                            :disabled="lockBtn"
                            data-toggle="tooltip"
                            data-placement="top"
                            @click="handleSubmit(cartAction)"
                            title="馬上購買"
                        >馬上購買
                        </button>
                    </div>
                    <div class="addcart-form" v-if="!product.ProductField?.preorderActive">
                        <button
                            type="button"
                            class="btn addcart-btn"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="加入購物車"
                            @click="handleSubmit(cartNoJumpAction)"
                            :disabled="lockBtn"
                        />
                    </div>
                </div>

                <div class="cart-bottom">
                    <div class="fb-like" :data-href="fbLikeUrl" data-width=""
                         data-layout="button" data-action="like" data-size="small"
                         data-share="true"/>
                    <ProductFavoriteComponent
                        :id="product.id"
                        :favorite-added="favoriteAdded"
                        :favorite-added-data="favoriteAddedData"
                        :page-type="'product'"
                        @change-favorite-added-data="handledChangeFavorite"
                    ></ProductFavoriteComponent>
                </div>
            </template>
        </template>
        <template v-else-if="pageType == 'course'">
            <div class="purchase-item">
                <div class="purchase-info">
                    <div class="price-item">
                        <span class="originalPrice" v-if="originalPrice">{{ originalPrice }}</span>
                        <div class="price-line">
                            <div class="total-price" v-cloak v-if="salePrice">
                                {{ salePrice }}
                            </div>
                            <div class="unit" v-if="specification.unit" v-cloak>/
                                {{ specification.unit }}
                            </div>
                        </div>
                        <div class="price-subline">
                            <div class="orderCount">
                                {{ allSalesTimes }}人 已購買
                            </div>
                            <div class="evaluation-line">
                                <div class="star-icon">
                                    <img :src="starIcon" alt="">
                                </div>
                                <span>{{ ratingScore }}</span>
                                <span v-if="ratingCount != 0">({{ ratingCount }})</span>
                            </div>
                        </div>
                    </div>
                    <div class="class-info">
                        <div class="class-icon flex">
                            <div class="content-left">
                                <div class="class-icon-pic"><img src="img/pic/video-bl.png" alt=""></div>
                                {{ product.courseTypeText }}
                            </div>
                            <div class="content-right">
                                <span class="class-tag badge" :class="specStatusClass">{{ specStatusTitle }}</span>
                            </div>
                        </div>
                        <div class="info-title-info">
                            <h2 class="info-title">{{ product.name }}</h2>
                            <template v-if="productType == 'tightBundle'">
                                <span class="info-sub-title">包含以下產品：</span>
                            </template>
                        </div>
                        <template v-if="productType == 'simple' && !alreadyBuy">
                            <template v-if="specifications?.length > 0">
                                <input type="hidden" :data-type_id_specId_key="typeIdSpecIdKey()"
                                       class="type_id_specId_key" name="type_id_specId_key[]"
                                       :value="typeIdSpecIdKey()">
                                <template v-if="product.courseType == 1">
                                    <div class="item-option">
                                        <h4><span class="class-type">課程日期</span></h4>
                                        <select class="drop-down-triangle" v-model="selectedDateId">
                                            <option v-for="item in specificationDates"
                                                    :value="item.specificationDatesId">{{
                                                    item.courseDate
                                                }}
                                            </option>
                                        </select>
                                        <div class="custom-arrow"></div>
                                    </div>
                                    <span class="class-type">方案選擇</span>
                                    <select class="drop-down-triangle" v-model="selectedProgramId">
                                        <option v-for="program in selectedDatePrograms"
                                                :value="program.specificationPlanId">
                                            {{ program.programName }}
                                        </option>
                                    </select>

                                    <div class="stock">剩餘數量：{{ getStockNum() }}
                                    </div>
                                </template>
                                <template v-else-if="product.courseType == 2">
                                    <div class="item-option">
                                        <span class="class-type">方案選擇</span>
                                        <select class="drop-down-triangle" v-model="selectedProgramId">
                                            <option v-for="program in selectedDatePrograms"
                                                    :value="program.specificationPlanId">
                                                {{ program.programName }}
                                            </option>
                                        </select>
                                    </div>
                                </template>
                            </template>
                            <!--方案簡介-->
                            <template v-if="specification.descriptionText">
                                <div class="class-icon">
                                    <div class="class-icon-pic"><img :src="editIcon" alt=""></div>
                                    方案簡介
                                </div>
                                <p v-html="specification.descriptionText"></p>
                            </template>
                            <!--上課地點-->
                            <template v-if="specAddress">
                                <div class="class-icon">
                                    <template v-if="isRemote">
                                        <div class="class-icon-pic">
                                            <font-awesome-icon icon="laptop"
                                                               :style="{ width: '20px', height: '20px' }"/>
                                        </div>
                                        上課地點
                                        <p>
                                            {{ specAddress }}
                                        </p>
                                    </template>
                                    <template v-else>
                                        <div class="class-icon-pic"><img :src="mapIcon" alt=""></div>
                                        上課地點
                                        <p class="info-line" v-html="specAddress"/>
                                        <br>
                                        <div class="addressIframe" v-if="specAddressIframe">
                                            <iframe :src="specAddressIframe" width="200" height="200" style="border:0;"
                                                    allowfullscreen=""
                                                    loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </template>
                        <template v-else-if="productType == 'tightBundle'">
                            <!--  組合商品選項  -->
                            <template v-if="productCombination">
                                <template v-for="(items, courseId) in productCombination">
                                    <div class="bundle-item">
                                        <div class="bundle-head flex">
                                            <img class="class-pic" :src="getCombinationCoursePic(items)"
                                                 @error="handleImageError" alt="">
                                            <div class="info flex">
                          <span class="class-name">
                            <a
                                v-bind:href="'course/' + getCombinationParentSlug(items)"
                                v-text="getCombinationParentName(items)">
										        </a>
                            <input type="hidden" class="type_id_specId_key"
                                   :data-type_id_specId_key="typeIdSpecIdKey(courseId, selectedProductCombinationIds[courseId])"
                                   name="type_id_specId_key[]"
                                   :value="typeIdSpecIdKey(courseId, selectedProductCombinationIds[courseId])">
                          </span>
                                                <!-- 數量 -->
                                                <span class="class-amount">數量：{{
                                                        getProductCombinationAmount(courseId)
                                                    }}</span>
                                                <div class="stock">剩餘數量：{{ getStockNum(courseId) }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="item-option">
                                            <div class="class-icon">
                                                <div class="class-icon-pic"><img :src="calendarIcon" alt=""></div>
                                                方案
                                            </div>
                                            <select class="drop-down-triangle"
                                                    @change="updateSelectedProductCombinationId(courseId, $event.target.value)">=
                                                <template v-if="!isAllExpired(items)">
                                                    <option v-for="item in items" :value="item.id"
                                                            v-if="!item?.isExpired">{{
                                                            item.courseDate + ' ' + item.programName
                                                        }}
                                                    </option>
                                                </template>
                                                <template v-else>
                                                    <option>已結束銷售</option>
                                                </template>

                                            </select>
                                            <div class="custom-arrow"></div>
                                        </div>
                                        <!--方案簡介-->
                                        <template>
                                            <div class="class-icon">
                                                <div class="class-icon-pic"><img :src="editIcon" alt=""></div>
                                                簡介
                                            </div>
                                            <p v-html="getDescriptionText(courseId)"></p>
                                        </template>
                                        <!--上課地點-->
                                        <template v-if="getCombinationAddress(courseId)">
                                            <div class="class-icon">
                                                <div class="class-icon-pic"><img :src="mapIcon" alt=""></div>
                                                上課地點
                                            </div>
                                            <p class="info-line" v-html="getCombinationAddress(courseId)"/>
                                        </template>
                                    </div>
                                </template>
                            </template>

                        </template>
                    </div>
                    <div class="stock"
                         v-if="!alreadyBuy && (specifications?.length > 0 || Object.keys(productCombination)?.length > 0)">
                        <div class="specTitle">數量</div>
                        <div class="stockInputBox">
                            <button class="qty minus" @click="decrement">-</button>
                            <input
                                type="number"
                                name="amount"
                                v-model="inputAmount"
                                :min="1"
                                :max="10000"
                            >
                            <button class="qty plus" @click="increment">+</button>
                        </div>
                    </div>
                </div>
                <div class="cart-item"
                     v-if="!alreadyBuy && (specifications?.length > 0 || Object.keys(productCombination)?.length > 0)">
                    <div class="cart-form">
                        <button
                            type="button"
                            class="btn cart-button"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="馬上購買"
                            @click="handleSubmit(cartAction)"
                            :disabled="lockBtn"
                        >馬上購買
                        </button>
                    </div>
                    <div class="addcart-form">
                        <button
                            type="button"
                            class="btn addcart-btn"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="加入購物車"
                            @click="handleSubmit(cartNoJumpAction)"
                            :disabled="lockBtn"
                        />
                    </div>
                </div>
                <div class="cart-bottom">
                    <div class="fb-like" :data-href="fbLikeUrl" data-width=""
                         data-layout="button" data-action="like" data-size="small"
                         data-share="true"/>
                    <FavoriteComponent
                        :id="product.id"
                        :favorite-added="favoriteAdded"
                        :favorite-added-data="favoriteAddedData"
                        :page-type="'course'"
                        @change-favorite-added-data="handledChangeFavorite"
                    ></FavoriteComponent>
                </div>
            </div>
        </template>
        <!-- Modal -->
        <div class="modal fade" id="MsgModal" tabindex="-1" role="dialog" aria-labelledby="MsgModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="MsgModalTitle">請先註冊會員</h5>
                    </div>
                    <div class="modal-body">網站轉換中，如果您在肌內效EX已經註冊會員，請再次註冊新平台會員，造成您的困擾，敬請見諒！</div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" onclick="javascript:location.href='user/register'">註冊</button>
                        <button type="button" class="btn btn-primary" onclick="javascript:location.href='user/login'">登入</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Datalayer from 'Controllers/Web/Datalayer';
import FavoriteComponent from 'Vue/Web/Shop/Course/FavoriteComponent.vue';
import ProductFavoriteComponent from 'Vue/Web/Shop/Product/FavoriteComponent.vue';
import specificationProgramPicker from 'Vue/Web/Shop/Course/Specification/SpecificationProgramPicker';
import onlineSpecificationProgramPicker from 'Vue/Web/Shop/Course/Specification/OnlineSpecificationProgramPicker.vue';
import EventBus from 'FF/Core/EventBus';
import swal from 'sweetalert';

export default {
    name: 'rightSideContent',
    components: {
        FavoriteComponent,
        specificationProgramPicker,
        onlineSpecificationProgramPicker,
        EventBus,
        ProductFavoriteComponent
    },
    props: {
        product: {
            type: Object,
            default: {},
        },
        pageType: {
            type: String,
            default: 'course',
        },
        specStatus: {
            type: Number,
            default: 1,
        },
        specifications: {
            type: Array,
            default: [],
        },
        ratingScore: {
            type: String,
            default: '0',
        },
        ratingCount: {
            type: Number,
            default: 0,
        },
        authCheck: {
            type: Boolean,
            default: false,
        },
        csrf: {
            type: String,
            default: '',
        },
        specificationPrograms: {
            type: Array,
            default: [],
        },
        specificationDates: {
            type: Array,
            default: [],
        },
        favoriteAdded: {
            type: Boolean,
            defalut: false,
        },
        favoriteAddedData: {
            type: Boolean,
            defalut: false,
        },
        productCombination: {
            type: Object,
            default: {},
        },
        alreadyBuy: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedDateId: null,
            selectedProgramId: null,
            inputAmount: 1,
            specification: {},
            mapIcon: 'img/pic/map.svg',
            editIcon: 'img/sample/editIcon.svg',
            starIcon: 'img/pic/star.png',
            calendarIcon: 'img/sample/calendar.svg',
            errorPic: 'img/pic/no_image_icon.png',
            specStatusAttr: [
                {
                    title: '待販售',
                    class: 'badge-warning',
                },
                {
                    title: '開課中',
                    class: 'badge-success',
                },
                {
                    title: '已完售',
                    class: 'badge-danger',
                },
                {
                    title: '募資中',
                    class: 'badge-success',
                },
                {
                    title: '許願中',
                    class: 'badge-warning',
                },
            ],
            selectedProductCombinationIds: {},
            productType: 'simple',
            fbLikeUrl: window.location.href,
            lockBtn: false,
            preOrderTitle: '預購倒數',
            countdownTimer: null, // 定時器
            remainingTime: {
                distance: 0, // 剩餘時間（毫秒）
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            },
        };
    },
    beforeMount() {
        Object.entries(this.productCombination)
            .forEach(([courseId, item]) => {
                let specId = item.find(combination => !combination.isExpired)?.id ?? '';
                this.$set(this.selectedProductCombinationIds, courseId, specId);
            });
        this.productType = this.product.productType;
    },
    mounted() {
        // 動態載入 Facebook SDK
        if (!document.getElementById('facebook-jssdk')) {
            const script = document.createElement('script');
            script.id = 'facebook-jssdk';
            script.async = true;
            script.defer = true;
            script.crossOrigin = 'anonymous';
            script.src = 'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v11.0&appId=1684858995007259&autoLogAppEvents=1';
            document.body.appendChild(script);
        }
        this.startCountdown();

        // 初始化 FB SDK
        this.initFacebookSDK();
    },
    beforeDestroy() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
        }
    },
    created() {
        if (this.pageType == 'course') {
            this.selectedDateId = this?.specificationDates[0]?.specificationDatesId;
            this.selectedProgramId = this?.specificationDates[0]?.specificationPrograms[0]?.specificationPlanId;
        } else {
            this.selectedProgramId = this?.specifications[0][0]?.id;
            if (this.productType !== 'tightBundle') {
                const validSpecification = this.specifications?.find(spec => spec[0]?.newStocknum > 0);
                if (validSpecification) {
                    this.specification = validSpecification[0];
                }
            }
        }

        /* set Title */
        this.getPreOrderStatus();
    },
    computed: {
        formClass() {

            let className = 'courseForm';

            if(this.pageType == 'product' && this.productType !== 'tightBundle') {
                className = ' productForm simple';
            }

            return className;
        },
        salePrice() {
            let price = null;
            switch (this.productType) {
                case 'simple':
                    price = this?.specification?.price ?? '';
                    break;
                case 'tightBundle':
                    Object.entries(this.selectedProductCombinationIds)
                        .forEach(([courseId, specId]) => {
                            const combinations = this.productCombination[courseId];
                            if (combinations) {
                                const selectedCombination = combinations.find(combination => combination.id == specId);
                                if (selectedCombination && selectedCombination.bundlePrice) {
                                    price += selectedCombination.bundlePrice;
                                }
                            }
                        });
                    if (price === null) {
                        return null;
                    }
                    break;
            }

            if (price === '') {
                return null;
            }

            return price ? 'NT$ ' + price + '元' : '免費';
        },
        originalPrice() {
            let price = null;

            switch (this.productType) {
                case 'simple':
                    if (this?.specification === undefined) {
                        price = '';
                    } else {
                        if (this.pageType == 'course') {
                            price = this?.specification?.originalPrice ?? '';
                        } else {
                            price = this?.specification?.priceOriginal ?? '';
                        }
                    }
                    break;
                case 'tightBundle':
                    Object.entries(this.selectedProductCombinationIds)
                        .forEach(([courseId, specId]) => {
                            const combinations = this.productCombination[courseId];
                            if (combinations) {
                                const selectedCombination = combinations.find(combination => combination.id == specId);
                                if (selectedCombination && selectedCombination.price) {
                                    price += selectedCombination.price;
                                }
                            }
                        });
                    break;
            }

            if (price === '') {
                return null;
            }

            return price ? '原價 NT$ ' + price + '元' : null;
        },
        selectedDatePrograms() {
            const selectedDate = this?.specificationDates.find(
                date => date.specificationDatesId === this.selectedDateId);
            return selectedDate ? selectedDate.specificationPrograms : [];
        },
        specStatusClass() {
            let specStatus = 2;
            if (this.specifications?.length > 0 || Object.keys(this.productCombination)?.length > 0) {
                specStatus = this.specStatus;
            }
            return this.specStatusAttr[specStatus].class;
        },
        specStatusTitle() {
            let specStatus = 2;
            if (this.specifications?.length > 0 || Object.keys(this.productCombination)?.length > 0) {
                specStatus = this.specStatus;
            }
            return this.specStatusAttr[specStatus].title;
        },
        cartAction() {
            // 计算表单的 action 属性
            let pageKey = this.pageType == 'course' ? 'coursecart' : 'cart';
            return `shop/order/${pageKey}/${this.authCheck ? 'addCart' : 'addCartNoJump'}`;
        },
        cartNoJumpAction() {
            // 计算表单的 action 属性
            let pageKey = this.pageType == 'course' ? 'coursecart' : 'cart';
            return `shop/order/${pageKey}/addCartNoJump`;
        },
        isRemote() {
            return this?.specification?.specificationDate?.address?.isRemote;
        },
        specAddress() {
            return this?.specification?.specificationDate?.address?.address;
        },
        specAddressDate() {
            return this?.specification?.specificationDate?.address?.date;
        },
        specAddressIframe() {

            let result = this?.specification?.specificationDate?.address?.iframe;
            if (result) {
                const srcRegex = /<iframe[^>]+src=['"]([^'"]+)['"]/;
                const match = result.match(srcRegex);
                const srcValue = match ? match[1] : null;
                return srcValue;
            }

            return null;
        },
        allSalesTimes() {
            return this.product.baseSalesTime + this.product.salesTime;
        },
    },
    methods: {
        initFacebookSDK() {
            // 檢查 SDK 是否載入完成
            const checkFB = () => {
                if (window.FB) {
                    window.FB.XFBML.parse(); // 初始化 Facebook 插件
                } else {
                    setTimeout(checkFB, 500); // 若未載入完成，稍後重試
                }
            };
            checkFB();
        },
        handleImageError(event) {
            event.target.src = this.errorPic;
        },
        getCombinationParentName(productCombination) {
            if (productCombination[0] && productCombination[0]?.parentName) {
                return productCombination[0].parentName;
            }
            return '';
        },
        getCombinationParentSlug(productCombination) {
            let productKey = this.pageType == 'course' ? 'Course' : 'Product';

            if (productCombination[0] && productCombination[0]?.[productKey]) {
                return productCombination[0][productKey].slug;
            }
            return '';
        },
        getCombinationCoursePic(productCombination) {
            let productKey = this.pageType == 'course' ? 'Course' : 'Product';
            if (productCombination[0] && productCombination[0][productKey]?.Pics[0]?.url?.w0h0) {
                return productCombination[0][productKey]?.Pics[0]?.url?.w0h0;
            }
            return '';
        },
        getCombinationAddress(courseId) {
            let selectedItem = this.productCombination[courseId].find(
                item => item.id == this.selectedProductCombinationIds[courseId]);
            return selectedItem?.specificationDate?.address?.address ?? '';
        },
        updateSelectedProductCombinationId(index, newValue) {
            this.$set(this.selectedProductCombinationIds, parseInt(index), parseInt(newValue));
        },
        getProductCombinationAmount(index) {
            let selectedItem = this.productCombination[index].find(
                item => item.id == this.selectedProductCombinationIds[index]);
            return selectedItem?.baseNumber ?? '1';
        },
        getDescriptionText(courseId) {
            let selectedItem = this.productCombination[courseId].find(
                item => item.id == this.selectedProductCombinationIds[courseId]);
            return selectedItem ? selectedItem.descriptionText : '';
        },
        selectSpec(specification) {
            this.specification = specification;
            this.selectedProgramId = specification.id;
        },
        updatePrograms() {
            this.selectedProgramId = this?.selectedDatePrograms[0]?.specificationPlanId;
            let currentSpec = this.selectedDatePrograms.find(
                program => program.specificationPlanId === this.selectedProgramId);
            this.inputAmount = currentSpec?.baseNumber;

            this.specification = currentSpec?.specification;
        },
        addToCartDatalayerPush() {
            let pageKey = this.pageType == 'course' ? 'coursecart' : 'cart';
            let postSpecIds = this.productType == 'tightBundle' ?
                this.selectedProductCombinationIds :
                [this?.specification.id];
            $.ajax({
                url: `shop/order/${pageKey}/getAddToCartDataLayer`,
                type: 'POST',
                data: {
                    amount: this.inputAmount,
                    itemId: this.product.id,
                    productType: this.productType,
                    specificationIds: postSpecIds,
                },
                dataType: 'json',
            })
                .done((response) => {
                    if (response != null) {
                        Datalayer.push(response);
                    }
                });
        },
        handleSubmit(cartAction) {
            if (!this.authCheck) {
                // 未登入，顯示提示 Modal
                this.showLoginModal();
            } else {
                // 已登入，執行購買邏輯
                this.submitForm(cartAction);
            }
        },
        showLoginModal() {
            $('#MsgModal').modal({
                backdrop: 'static',
                keyboard: false,
            });
        },
        async submitForm(url) {
            this.lockBtn = true;
            let proceed = true;
            if (this.product?.ProductField?.preorderActive) {
                proceed = await this.preOrderConfirm();
            }
            this.addToCartDatalayerPush();

            if (this.specStatus == 2) {
                this.lockBtn = false;
                global.Message.show(this.product.name + ' 庫存不足', 3);
                return;
            }

            if (proceed) {
                let formData = {
                    _token: this.csrf,
                    specificationId: [this?.specification?.id],
                    productId: this.product?.id,
                    amount: this.inputAmount,
                    productType: this.productType,
                    combinationIds: this.selectedProductCombinationIds,
                };

                axios.post(url, formData)
                    .then(response => {

                        if (response.data.status === 'fails') {
                            this.lockBtn = false;
                            global.Message.show(response.data.text, 3);
                            return;
                        }

                        let redirectUrl = response.data?.url;
                        if (redirectUrl) {
                            window.location = redirectUrl;
                            return;
                        }

                        // 處理成功響應
                        let script = response.data?.script;
                        this.lockBtn = false;

                        if (script) {
                            eval(script);
                        }

                        global.Message.show(response.data.text, 3);
                        /* 觸發mini cart reload */
                        $('#loadOrder')
                            .click();

                    })
                    .catch(error => {
                        // 處理錯誤
                        this.lockBtn = false;
                        global.Message.show('系統錯誤', 3);
                    });
            }

        },
        async preOrderConfirm() {
            const willAdd = await swal({
                title: '確認購買預購商品?',
                text: '由於預購商品需要獨立結帳, 將會清空購物車現有的商品',
                icon: 'warning',
                buttons: true,
                dangerMode: true,
            });

            return willAdd;
        },
        handledChangeFavorite(data) {
            EventBus.$emit('changeFavoriteAddedData', data);
        },
        decrement() {
            if (this.inputAmount > 1) {
                this.inputAmount = parseInt(this.inputAmount, 10) - 1;
            } else {
                this.inputAmount = 1;
            }
        },
        increment() {
            if (this.inputAmount > 0) {
                this.inputAmount = parseInt(this.inputAmount, 10) + 1;
            } else {
                this.inputAmount = 1;
            }
        },
        getStockNum(id = null) {
            let stock = null;
            switch (this.productType) {
                case 'simple':
                    stock = this?.specification.newSkuActive ?
                        this?.specification.newStocknum : this?.specification.stocknum;
                    break;
                case 'tightBundle':
                    let selectedProductCombinationId = this.selectedProductCombinationIds[id];

                    const combinations = this.productCombination[id];
                    if (combinations) {
                        const selectedCombination = combinations.find(
                            (combination) => combination.id == selectedProductCombinationId);
                        if (selectedCombination) {
                            stock = selectedCombination.newSkuActive ?
                                selectedCombination.newStocknum : selectedCombination.stocknum;
                        }
                    }

                    break;
            }
            return stock ?? 0;
        },
        isAllExpired(options) {
            return options.every((item) => item.isExpired === true);
        },
        typeIdSpecIdKey(productId = this.product.id, specId = this.specification.id) {
            return `${this.pageType}_${productId}_${specId}`;
        },
        getPreOrderStatus() {
            if (this.product?.ProductField?.preorderActive) {
                const now = new Date();
                const fromDate = new Date(this.product.ProductField?.preorderFromDate);
                const toDate = new Date(this.product.ProductField?.preorderToDate);

                if (fromDate < now && toDate >= now) {
                    this.preOrderTitle = '預購倒數';
                    return 'start';
                } else if (fromDate > now) {
                    this.preOrderTitle = '預購尚未開始';
                    return 'notStart';
                } else {
                    this.preOrderTitle = '預購已結束';
                    return 'end';
                }
            } else {
                return 'notPreOrder';
            }
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        startCountdown() {
            const toDate = this.product?.ProductField?.preorderToDate;
            if (this.product?.ProductField?.preorderActive && toDate) {
                const countDownDate = new Date(toDate.replace(/-/g, '/')).getTime();

                this.countdownTimer = setInterval(() => {
                    const now = Date.now();
                    const distance = countDownDate - now;

                    if (distance < 0) {
                        clearInterval(this.countdownTimer);
                        this.resetCountdown();
                        return;
                    }

                    this.remainingTime = {
                        distance,
                        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                        seconds: Math.floor((distance % (1000 * 60)) / 1000),
                    };
                }, 1000);
            }
        },
        resetCountdown() {
            this.remainingTime = {
                distance: 0,
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            };
        },
    },
    watch: {
        selectedDateId() {
            this.updatePrograms();
        },
        selectedProgramId() {
            if (this.pageType == 'course') {
                let currentSpec = this.selectedDatePrograms.find(
                    program => program.specificationPlanId === this.selectedProgramId);
                this.inputAmount = currentSpec?.baseNumber ?? 1;

                this.specification = currentSpec?.specification ?? [];

            } else {
                // let currentSpec = null;
                // for (const [index, specification] of Object.entries(this?.specifications)) {
                //   currentSpec = specification.find(
                //       program => program.id == this.selectedProgramId
                //   );
                //
                //   if (currentSpec) {
                //     break; // 如果找到了匹配的 program，就中斷循環
                //   }
                // }
                // let stocknum = this?.specification?.newSkuActive ? this?.specification?.newStocknum : this?.specification?.stocknum;
                // this.inputAmount = stocknum > 0 ? 1 : 0;
                // this?.specification = currentSpec;
            }
        },
        inputAmount(value) {
            if (this.specStatus == 2) {
                this.inputAmount = 0;
                return;
            }
            if (this.pageType == 'course') {
                let baseNumber = this.selectedDatePrograms.find(
                    program => program.specificationPlanId === this.selectedProgramId)?.baseNumber;

                if (value < baseNumber) {
                    this.inputAmount = baseNumber;
                }

                if (this.product.courseType == 2 && this.inputAmount == 0) {
                    this.inputAmount = 1;
                }
            } else {
                // if(this.productType == 'simple'){
                //   let stocknum = this?.specification?.newSkuActive ? this?.specification?.newStocknum : this?.specification?.stocknum;
                //   if (value > stocknum) {
                //     this.inputAmount = stocknum;
                //   }
                // }
                this.inputAmount = value < 1 ? 1 : value;
            }
        },
    }
};
</script>

<style scoped lang="scss">

$maincolor: #72ca4a;
$smallstandard:#555;
$bigstandard: #333;
$character: #666;
$bgcolor: #eee;

.originalPrice {
    text-decoration: line-through;
    color: #7e7e7e;
    font-weight: bold;
}

.info-title-info {
    margin-bottom: 1rem;

    .info-sub-title {
        font-size: 1rem;
    }
}


.item-option {
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.drop-down-triangle {
    width: 100%;
    min-height: 45px;
    word-wrap: break-word;
    white-space: normal;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-right: 35px;
    background: white url('/img/pic/arrow-down-sign.png') no-repeat right center;
    background-position-x: calc(100% - 12px);
    background-size: 12px;
    padding-left: 10px;

}

.flex {
    display: flex;
}

.class-icon {
    margin-top: 1rem;

    .content-right {
        margin-left: auto;
        font-size: 14px;

        .class-tag {
            position: relative;
            top: 0;
            left: 0;
        }
    }
}

.purchase-info {
    background: #eee;
    border: 1px solid #ccc;
    margin-bottom: 1rem;
    padding: 2rem;

    .stock {
        color: #666;

        .specTitle {
            font-size: 14px;
            margin-bottom: 6px;
        }

        .stockInputBox {
            display: flex;

            input {
                width: 70px;
                height: 35px;
                text-align: center;
                border-radius: 0;
                border: solid 1px #666;
                line-height: 18px;
                padding: 5px;
                margin-bottom: 3px;
                transition: border 0.5s;

                &::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                }
            }

            .qty {
                width: 35px;
                height: 35px;
                border: solid 1px #666;
                background: #fff !important;
                font-size: 20px;
                color: #666;

                &:hover {
                    background: #72ca4a;
                    color: white;
                    transition: 0.3s;
                }

                &.minus {
                    border-right: none;
                }

                &.plus {
                    border-left: none;
                }
            }
        }

        .stock-less {
            margin-top: 1rem;
        }
    }
}

.bundle-item {
    border-top: 1px solid #ccc;
    margin-bottom: 1rem;

    .bundle-head {
        margin-top: 1rem;
        margin-bottom: 1rem;

        .class-pic {
            height: 50px;
            width: auto;
            max-width: 120px;
            flex: 4;
        }

        .info {
            flex: 6;
            padding-left: 1rem;
            flex-direction: column;

            .class-name, .class-amount {
                flex: 1;
                display: block;
                color: #666;
            }
        }
    }

    .class-icon {
        margin-bottom: 1rem;
        margin-top: 0rem;
    }

    .item-option {
        .class-icon-pic {
            display: inline-block;
            width: 20px;
            line-height: 20px;
            margin-right: 0.5rem;
            opacity: 0.7;
        }
    }
}

.cart-item {
    display: flex;
    margin-bottom: 1rem;
    height: 50px;

    .cart-form {
        flex: 6;

        .cart-button {
            height: 100%;
            width: 95%;
            background: #72ca4a;
            color: white;
            margin-right: 1rem;
            font-size: 15px;
            transition: 0.3s;
            line-height: 2.5;

            &:hover {
                background: #91d671;
                transition: 0.3s;
            }
        }
    }

    .addcart-form {
        .addcart-btn {
            height: 50px;
            width: 50px;
            border: solid 2px #72ca4a;
            background: url(../img/pic/addcart_btn.png);
            background-size: contain;

            &:hover {
                ransition: 0.3s;
                background: url(../img/pic/addcart_btn_white.png);
                background-size: contain;
            }
        }
    }
}

.productForm {
    .purchase-info {
        padding: 2rem;
    }

    .synopsis {
        margin-top: 0px !important;
        margin-bottom: 1rem !important;
    }

    .bundle-item {
        .bundle-head .class-pic {
            flex: 2;
            height: auto;
            width: 60px;
        }

        .class-icon-pic {
            font-size: 20px;
        }
    }
}
.productForm {
    &.simple {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-left: 5%;
        color: #666;
        @media (max-width: 1024.98px) {
            float: none;
            width: 100%;
            margin-left: 0;
        }
        .title {
            font-size: 24px;
            color: #333;
            margin-bottom: 10px;
        }
        .priceBox {
            display: flex;
            justify-content: space-between;
            .originalPrice {
                position: relative;
                display: inline-block;
                color: #999;
                &::before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 0;
                    width: 100%;
                    height: 1px;
                    background-color: #999;
                }
            }
            .price {
                color: $maincolor;
                font-size: 20px;
                margin-bottom: 15px;
            }
            .ratingNumber {
                display: flex;
                align-items: center;
                margin-bottom: 6px;
                justify-content: flex-end;
                font-weight: 500;
                img {
                    width: 18px;
                    margin-right: 6px;
                }
                span {
                    color: #999;
                    margin-left: 3px;
                }
            }
        }
        .specTitle {
            font-size: 14px;
            margin-bottom: 6px;
        }
        .SpecificationPicker {
            overflow: hidden;
            margin-bottom: 5px;
            span {
                float: left;
                display: block;
                cursor: pointer;
                transition: 0.3s;
                margin-right: 10px;
                margin-bottom: 1rem;
                padding: 10px 20px;
                font-size: 14px;
                line-height: 14px;
                letter-spacing: 3px;
                border: solid 1px #555;
                color: #555;
            }
            .specificationBtn {
                &:hover,
                &.active {
                    color: white;
                    background: #72ca4a;
                    border: solid 1px rgba(0, 0, 0, 0);
                }
            }
            .invalidSpecificationBtn {
                background: #eee;
                color: #bbb;
            }
        }
        .stock {
            .stockInputBox {
                display: flex;
                input {
                    width: 70px;
                    height: 35px;
                    text-align: center;
                    border-radius: 0;
                    border: solid 1px #666;
                    color: #666;
                }
                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                .qty {
                    width: 35px;
                    height: 35px;
                    border: solid 1px #666;
                    background: none;
                    font-size: 20px;
                    color: #666;
                    &.minus {
                        border-right: none;
                    }
                    &.plus {
                        border-left: none;
                    }
                    &:active,
                    &:hover {
                        background: $maincolor;
                        color: white;
                        transition: 0.3s;
                    }
                }
            }
            .stockText {
                color: #888;
                margin-top: 5px;
                font-size: 13px;
            }
        }
        .synopsis {
            font-size: 14px;
            margin-top: 20px;
            margin-bottom: 20px;
            word-wrap: break-word;
            @media (max-width: 1024.98px) {
                margin-bottom: 2rem;
            }
            p {
                margin-bottom: 0.8rem;
            }
            h1,h2,h3,h4,h5 {
                font-size: 14px !important;
            }
        }
        .addCartBox {
            display: flex;
            margin-bottom: 1rem;
            min-height: 50px;
            .addCartNoJump,
            .addCartNoJump {
                .btn {
                    padding: 20%;
                    transition: 0.3s;
                    &:hover {
                        padding: 15%;
                    }
                }
            }
        }
    }
}

.cart-bottom {
    display: flex;
    align-items: center;
    height: 40px;

    .fb-like {
        height: 20px;
    }
}

.info-line {
    margin-top: 1rem;
}
</style>
